module.exports = __webpack_public_path__ + "img/1-2.68362802.jpg";